import { BaseModel } from "paliari-js-utils"
import DocCalculo from "./DocCalculo"
import DocIrregularidade from "./DocIrregularidade"

const attributes = {
  osm: {
    texto_para_implantar: "",
    minimo_fotos: null,
    limite_autuacao: null,
    permite_mesmo_em_andamento: false,
    permite_defesa: false,
    vistoria_mesmo_fiscal: false,
    bloqueia_fundo_vale: false,
    prazo_vencimento_debito: null,
    altera_situacao_mobiliario: null,
    calculo: p => new DocCalculo(p),
    irregularidades: (arr = []) => arr.map(item => new DocIrregularidade(item)),
  },
}

class DocModeloParams extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
  }
}

export default DocModeloParams
